(function () {
  function setup(wrapper) {
    var slider = wrapper.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!slider) return;
    var list = slider.querySelector('ul[id^="Slider-Gallery-"]');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.children).filter(function (li) {
      return li.id && li.id.indexOf('Slide-') === 0;
    });
    if (slides.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'cw-product-dots';

    slides.forEach(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to picture ' + (i + 1) + ' of ' + slides.length);
      if (slide.classList.contains('is-active')) b.classList.add('is-active');
      b.addEventListener('click', function () {
        list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    slider.appendChild(dots);

    slider.addEventListener('slideChanged', function (e) {
      var idx = (e.detail && e.detail.currentPage ? e.detail.currentPage : 1) - 1;
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.classList.toggle('is-active', i === idx);
      });
    });
  }

  document.querySelectorAll('.product__media-wrapper').forEach(setup);
})();
